import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1663 14L8.49967 10.6667L3.83301 14V3.33333C3.83301 2.97971 3.97348 2.64057 4.22353 2.39052C4.47358 2.14048 4.81272 2 5.16634 2H11.833C12.1866 2 12.5258 2.14048 12.7758 2.39052C13.0259 2.64057 13.1663 2.97971 13.1663 3.33333V14Z",
		stroke: "#50566E",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBookmark;
